import { useIsPaidPortal } from '../inventory/useProductInventory';
import { useIsInAppAuth } from '../user/useUserInfo';
export const useAddOnsPage = () => {
  const {
    isPaidPortal,
    loading: isInventoryLoading
  } = useIsPaidPortal();
  const isAppAuth = useIsInAppAuth();
  const showAddonsPage = isAppAuth && isPaidPortal && !isInventoryLoading;
  return {
    showAddonsPage,
    loading: isInventoryLoading
  };
};